var React = require('react');

function StarterInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12 3L1 9L12 15L21 10.09V17H23V9L12 3ZM5 13.18V17.18L12 21L19 17.18V13.18L12 17L5 13.18Z"}));
}

StarterInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"black"};

module.exports = StarterInline;

StarterInline.default = StarterInline;
